import type { ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { AppErrorBoundary } from '@/components/error/AppErrorBoundary';
import { Toaster } from '@/components/ui/sonner';
import { queryClient } from '@/lib/queryClient';
import { ThemeProvider } from './ThemeProvider';

interface AppProvidersProps {
	children: ReactNode;
}

/**
 * Composes every application-wide provider in one place so `App.tsx`
 * stays declarative and provider order is explicit.
 */
export function AppProviders({ children }: AppProvidersProps) {
	return (
		<AppErrorBoundary>
			<ThemeProvider>
				<QueryClientProvider client={queryClient}>
					{children}
					<Toaster position="bottom-right" closeButton />
				</QueryClientProvider>
			</ThemeProvider>
		</AppErrorBoundary>
	);
}
